import useDisabledButtonWithDebounce from '@/features/v2/hooks/useDissabledButtonWithDebounce';
import useScrollToStep from '@/features/v2/hooks/useScrollToStep';

import Button, { ButtonRightArrow } from '@/components/ui/Button';
import { useStepper } from '@/features/v2/lib/stepper';
import cn from '@/utils/cn';

import { useLingui } from '@lingui/react';

export type NextButton = {
  label?: string;
  hidden?: boolean;
  handleSubmit?: () => void;
  uniqTestId?: string;
  withTrigger?: boolean;
};
export const MoveForwardButton = ({
  label,
  hidden,
  handleSubmit,
  uniqTestId,
}: NextButton) => {
  const { i18n } = useLingui();

  const { isDisabled } = useDisabledButtonWithDebounce();
  const { innerStep, currentStep } = useStepper();
  const { isButtonDisabled, forceDisableButton } = useStepper();

  const completeValidation = !!currentStep?.completeValidation?.(innerStep);

  const { ref, setClicked } = useScrollToStep();

  return (
    <div ref={ref} className="w-full md:max-w-max">
      <Button
        type={handleSubmit ? 'button' : 'submit'}
        className={cn(
          'w-full transition-colors duration-200 ease-in-out md:w-auto',
          hidden && 'hidden'
        )}
        onClick={(e) => {
          // The step transition keeps this button mounted at the same tree
          // position, so the browser's :focus state would otherwise carry
          // over onto the next step's forward button.
          e.currentTarget.blur();
          return handleSubmit ? handleSubmit() : setClicked;
        }}
        disabled={
          !completeValidation &&
          (isDisabled || isButtonDisabled || forceDisableButton)
        }
        data-testid={`move-forward-button-${uniqTestId}`}
      >
        {label || i18n.t('Przejdź dalej')}
        <ButtonRightArrow />
      </Button>
    </div>
  );
};
